import {
  Annotation,
  AnnotationType,
  ArrowAnnotation,
  CanvasCursor,
  CircleAnnotation,
  HandleId,
  HandleInfo,
  PenAnnotation,
  RectangleAnnotation,
} from '../types';

export const getHandles = (a: Annotation): HandleInfo[] => {
  switch (a.type) {
    case AnnotationType.Rectangle: {
      const r = a as RectangleAnnotation;
      const { origin, width, height } = r;
      return [
        { id: HandleId.TopLeft, x: origin.x, y: origin.y, cursor: CanvasCursor.ResizeNwse },
        { id: HandleId.TopRight, x: origin.x + width, y: origin.y, cursor: CanvasCursor.ResizeNesw },
        { id: HandleId.BottomLeft, x: origin.x, y: origin.y + height, cursor: CanvasCursor.ResizeNesw },
        { id: HandleId.BottomRight, x: origin.x + width, y: origin.y + height, cursor: CanvasCursor.ResizeNwse },
        { id: HandleId.TopMid, x: origin.x + width / 2, y: origin.y, cursor: CanvasCursor.ResizeNs },
        { id: HandleId.BottomMid, x: origin.x + width / 2, y: origin.y + height, cursor: CanvasCursor.ResizeNs },
        { id: HandleId.MidLeft, x: origin.x, y: origin.y + height / 2, cursor: CanvasCursor.ResizeEw },
        { id: HandleId.MidRight, x: origin.x + width, y: origin.y + height / 2, cursor: CanvasCursor.ResizeEw },
      ];
    }
    case AnnotationType.Circle: {
      const c = a as CircleAnnotation;
      const { center, radiusX, radiusY } = c;
      return [
        { id: HandleId.Top, x: center.x, y: center.y - radiusY, cursor: CanvasCursor.ResizeNs },
        { id: HandleId.Right, x: center.x + radiusX, y: center.y, cursor: CanvasCursor.ResizeEw },
        { id: HandleId.Bottom, x: center.x, y: center.y + radiusY, cursor: CanvasCursor.ResizeNs },
        { id: HandleId.Left, x: center.x - radiusX, y: center.y, cursor: CanvasCursor.ResizeEw },
        { id: HandleId.TopLeft, x: center.x - radiusX, y: center.y - radiusY, cursor: CanvasCursor.ResizeNwse },
        { id: HandleId.TopRight, x: center.x + radiusX, y: center.y - radiusY, cursor: CanvasCursor.ResizeNesw },
        { id: HandleId.BottomLeft, x: center.x - radiusX, y: center.y + radiusY, cursor: CanvasCursor.ResizeNesw },
        { id: HandleId.BottomRight, x: center.x + radiusX, y: center.y + radiusY, cursor: CanvasCursor.ResizeNwse },
      ];
    }
    case AnnotationType.Arrow: {
      const ar = a as ArrowAnnotation;
      return [
        { id: HandleId.Start, x: ar.start.x, y: ar.start.y, cursor: CanvasCursor.Move },
        { id: HandleId.End, x: ar.end.x, y: ar.end.y, cursor: CanvasCursor.Move },
      ];
    }
    case AnnotationType.Pen:
    case AnnotationType.Highlighter: {
      const pen = a as PenAnnotation;
      if (pen.points.length < 2) return [];
      const xs = pen.points.map((p) => p.x);
      const ys = pen.points.map((p) => p.y);
      const minX = Math.min(...xs);
      const maxX = Math.max(...xs);
      const minY = Math.min(...ys);
      const maxY = Math.max(...ys);
      return [
        { id: HandleId.TopLeft, x: minX, y: minY, cursor: CanvasCursor.ResizeNwse },
        { id: HandleId.TopRight, x: maxX, y: minY, cursor: CanvasCursor.ResizeNesw },
        { id: HandleId.BottomLeft, x: minX, y: maxY, cursor: CanvasCursor.ResizeNesw },
        { id: HandleId.BottomRight, x: maxX, y: maxY, cursor: CanvasCursor.ResizeNwse },
      ];
    }
    default:
      return [];
  }
};
